var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco3Proceso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico_3_proceso",
    transform: "translate(-1000 -1911)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6459",
    "data-name": "Rectangle 6459",
    width: 228,
    height: 228,
    transform: "translate(1000 1911)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8145",
    "data-name": "Group 8145",
    transform: "translate(1012.836 1931.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19655",
    "data-name": "Path 19655",
    d: "M1973.311,473.81c-5.7.357-10.622,2.761-15.781,5-7.127,3.09-15.334,6.733-23.3,5.824-5.9-.673-11.484-3.026-16.989-5.125-5.634-2.148-11.565-4.614-17.648-5-4.348-.277-7.917.93-10.645,3.665v13.213c0,3.075,2.035,5.567,4.545,5.567h4.426v2.257a7.745,7.745,0,0,0,7.745,7.746h56.24a7.745,7.745,0,0,0,7.746-7.746v-2.257h3.617c2.51,0,4.544-2.492,4.544-5.567V473.74C1976.311,473.709,1974.81,473.716,1973.311,473.81Z",
    transform: "translate(-1825.281 -369.621)",
    fill: "#80cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19656",
    "data-name": "Path 19656",
    d: "M2115.79,289.322c-3.4-.023-5.637,3.547-6.648,6.8-4.576,14.694,1.326,31.81-5.9,45.4-2.713,5.1-7.028,9.129-11.264,13.056l-22.812,21.148c-1.277,1.183-2.486,3.467-.986,4.352a2.734,2.734,0,0,0,1.65.205c16.307-1.494,29.925-13.117,40.14-25.915,3.47-4.347,6.736-8.98,8.508-14.252a51.629,51.629,0,0,0,2.119-12.669,265.282,265.282,0,0,0,.5-30.79,8.941,8.941,0,0,0-.922-4.3,3.136,3.136,0,0,0-3.771-1.49",
    transform: "translate(-1917.511 -274.359)",
    fill: "#80cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19657",
    "data-name": "Path 19657",
    d: "M1967.881,412.1h-3.618v-2.258a7.746,7.746,0,0,0-7.745-7.746h-56.24a7.746,7.746,0,0,0-7.746,7.746V412.1h-4.426c-2.51,0-4.544,2.492-4.544,5.567v25.926c0,3.075,2.035,5.567,4.544,5.567h4.426v2.257a7.746,7.746,0,0,0,7.746,7.746h56.24a7.746,7.746,0,0,0,7.745-7.746v-2.257h3.618c2.51,0,4.544-2.492,4.544-5.567V417.669C1972.425,414.594,1970.391,412.1,1967.881,412.1Z",
    transform: "translate(-1822.498 -332.619)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8130",
    "data-name": "Group 8130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19658",
    "data-name": "Path 19658",
    d: "M1820.381,463.28a2.458,2.458,0,0,1-.384-.851c-.386-1.572-.728-3.174-1.018-4.793a42.892,42.892,0,0,0-31.1,41.185v24.841l2.771.124a2.894,2.894,0,0,1-.128,5.786h-24.58a2.9,2.9,0,1,1,0-5.81h4.029V498.82a60.824,60.824,0,0,1,48.6-59.5,18.242,18.242,0,0,1,2.331-6.295,66.624,66.624,0,0,0-56.733,65.8v19.322a8.706,8.706,0,0,0,1.772,17.23h24.58a8.7,8.7,0,0,0,3.158-16.8V498.82A37.072,37.072,0,0,1,1820.381,463.28Z",
    transform: "translate(-1757.24 -348.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19659",
    "data-name": "Path 19659",
    d: "M2119.4,258.368h-24.2a8.921,8.921,0,0,0-2.55,17.47v29.22a37.077,37.077,0,0,1-24.4,34.8,13.532,13.532,0,0,1,1.77,5.528,42.888,42.888,0,0,0,28.434-40.329V270.408H2095.2a3.12,3.12,0,0,1,0-6.239h24.2a3.12,3.12,0,1,1,0,6.239h-3.044v34.649a60.828,60.828,0,0,1-46.98,59.153,18.844,18.844,0,0,1,.154,5.905,66.634,66.634,0,0,0,52.627-65.058V275.773a8.921,8.921,0,0,0-2.757-17.4Z",
    transform: "translate(-1917.906 -258.368)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 107.233,
    cy: 107.233,
    r: 107.233,
    transform: "translate(1007 1918)",
    fill: "#fff",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco3Proceso);
export default __webpack_public_path__ + "static/media/ico_3_proceso.aa4d624525e8dab309c51e8558dff4b5.svg";
export { ForwardRef as ReactComponent };